import React from 'react'
import { Form } from 'react-bootstrap'
import { User } from 'interfaces/user'

interface OrganizationFiltersProps {
  searchTerm: string
  setSearchTerm: (term: string) => void
  accountManagerFilter: string
  setAccountManagerFilter: (filter: string) => void
  salesRepFilter: string
  setSalesRepFilter: (filter: string) => void
  sortOrder: 'asc' | 'desc'
  setSortOrder: (order: 'asc' | 'desc') => void
  internalAdmins?: User[]
}

const OrganizationFilters: React.FC<OrganizationFiltersProps> = ({
  searchTerm,
  setSearchTerm,
  accountManagerFilter,
  setAccountManagerFilter,
  salesRepFilter,
  setSalesRepFilter,
  sortOrder,
  setSortOrder,
  internalAdmins = [],
}) => {
  return (
    <div className="d-flex flex-wrap gap-2">
      <div style={{ minWidth: '200px', flex: '1' }}>
        <Form.Control
          type="text"
          placeholder="Search Organizations"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div style={{ minWidth: '200px', flex: '1' }}>
        <Form.Control
          as="select"
          value={accountManagerFilter}
          onChange={(e) => setAccountManagerFilter(e.target.value)}
        >
          <option value="">Account Manager</option>
          <option value="missing">Missing Account Manager</option>
          {internalAdmins?.map((admin: User) => (
            <option key={admin.id} value={admin.id}>
              {admin.name || admin.first_name || admin.email}
            </option>
          ))}
        </Form.Control>
      </div>
      <div style={{ minWidth: '200px', flex: '1' }}>
        <Form.Control
          as="select"
          value={salesRepFilter}
          onChange={(e) => setSalesRepFilter(e.target.value)}
        >
          <option value="">Sales Rep</option>
          <option value="missing">Missing Sales Rep</option>
          {internalAdmins?.map((admin: User) => (
            <option key={admin.id} value={admin.id}>
              {admin.name || admin.first_name || admin.email}
            </option>
          ))}
        </Form.Control>
      </div>
      <div style={{ minWidth: '200px', flex: '1' }}>
        <Form.Control
          as="select"
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value as 'asc' | 'desc')}
        >
          <option value="desc">Sort by Created Date</option>
          <option value="desc">Newest First</option>
          <option value="asc">Oldest First</option>
        </Form.Control>
      </div>
    </div>
  )
}

export default OrganizationFilters
